import { StepFour, StepOne, StepThree, StepTwo } from '../helpers/step'
import { StepState } from '../types/steps'

export enum StepIDs {
    ONE = 'step-one',
    TWO = 'step-two',
    THREE = 'step-three',
    FOUR = 'step-four',
}

export const initialSteps = [
    new StepOne({
        title: 'STO.STEPS.1.TITLE',
        state: StepState.PENDING,
    }),
    new StepTwo({
        title: 'STO.STEPS.2.TITLE',
        description: 'STO.STEPS.2.DESCRIPTION',
    }),
    new StepThree({
        title: 'STO.STEPS.3.TITLE',
    }),
    new StepFour({
        title: 'STO.STEPS.4.TITLE',
        description: 'STO.STEPS.4.DESCRIPTION',
        secondaryDescription: 'STO.STEPS.4.DESCRIPTION_IF_EXTERNAL_SIGNER',
    }),
]
